export default __webpack_public_path__ + "static/pastaroller-37b21db6bd898ef3a3bb9bdbaaac9a3c.png";